<template>
  <div>
    <template v-if="isWrittenResponse">
      <div :class="[isIM ? '' : 'ml-60', 'open-text-well']">
        <written-answer :answer="Object.values(answers)[0]" :skills="skills" />
      </div>
    </template>
    <template v-else-if="Object.values(answers).length">
      <div :class="[isIM ? '' : 'ml-60', 'well']">
        <template v-if="isMultiSelect">
          <div class="row mb-10 ml-5">
            <span
              ><b><i>Participants will be able to select multiple options below.</i></b></span
            >
          </div>
        </template>
        <ul id="response-list">
          <template v-for="answer in answers">
            <li
              :key="`${answer.answerKey}-nameTagKey`"
              :class="[isMultiSelect ? 'square-style' : 'circle-style']"
            >
              <answer :answer="answer" :skills="skills" class="mb-10" />
            </li>
          </template>
        </ul>
      </div>
    </template>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  import Answer from './Answer.vue';
  import WrittenAnswer from './WrittenAnswer.vue';

  export default {
    props: {
      questionType: {
        type: Number,
        required: true,
      },
      displayType: {
        type: Number,
        required: true,
      },
      answers: {
        type: Object,
        required: false,
      },
    },

    components: {
      Answer,
      WrittenAnswer,
    },
    computed: {
      ...mapState('editMode/skills', ['skills']),

      isWrittenResponse() {
        return this.questionType === 3;
      },

      isMultiSelect() {
        return this.questionType === 2;
      },

      isIM() {
        return this.displayType === 2;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .well {
    background: none;
  }

  @media print {
    .well {
      margin-bottom: 0px;
    }
  }
  .open-text-well {
    background-color: rgb(242, 242, 242);
    border: 2px solid lightgray;
  }
  .bg-style {
    background-color: rgb(242, 242, 242);
    border-radius: 5px;
  }

  #response-list li p {
    margin-bottom: 5px;
    display: inline-block;
    border-radius: 2px;
    padding: 4px;
  }

  #response-list li.square-style {
    list-style-type: square;
  }

  #response-list li.circle-style {
    list-style-type: disc;
  }

  #response-list {
    padding-left: 20px;
  }
</style>
